<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <comision-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import ComisionProvider from "../../../../providers/ComisionProvider";
    
    import {CrudUpdate, ClientError} from '@dracul/common-frontend'
    
    import ComisionForm from "../ComisionForm";
  
    

    export default {
        name: "ComisionUpdate",
        
        components: { ComisionForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'cobrox.comision.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                id: this.item.id,
                form: {
                    agencia: this.item.agencia ? this.item.agencia.id : null,
                    compra: this.item.compra ? this.item.compra.id : null,
                    ratioDesde: this.item.ratioDesde,
                    ratioHasta: this.item.ratioHasta,
                    comision: this.item.comision
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    ComisionProvider.updateComision(this.id, this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.updateComision)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>

